"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.REVIEW_FINDING_VERDICTS = exports.PAGE_LEVEL_SECTION_TYPE = exports.REVIEW_SUGGESTED_ACTIONS = exports.REVIEW_CATEGORIES = exports.REVIEW_SEVERITIES = void 0;
// The backend Zod schema (llm/schemas/storefront-review.schema.ts) builds
// its enums from these const arrays so the two cannot drift.
exports.REVIEW_SEVERITIES = ['CRITICAL', 'MAJOR', 'MINOR'];
exports.REVIEW_CATEGORIES = [
    'VISUAL_HIERARCHY',
    'COPY_QUALITY',
    'PAGE_FLOW',
    'CTA_PROMINENCE',
    'IMAGERY',
    'BRAND_CONSISTENCY',
    'MOBILE_USABILITY',
    'HYPOTHESIS_DELIVERY',
    'REFERENCE_FIDELITY',
    'REDUNDANCY',
];
// Revision rewrites sections in place. ADD_SECTION and REPLACE_SECTION
// create a native section next to the anchored one (REPLACE also removes the
// anchor). A page-level finding (sectionIndex null, type PAGE) is applied
// only as UPDATE_SETTINGS or ADJUST_FLOATING_CTA; OTHER is advisory and
// never applied.
exports.REVIEW_SUGGESTED_ACTIONS = [
    'REWRITE_COPY',
    'RESTYLE_SECTION',
    'REPLACE_IMAGE',
    'REWRITE_HTML',
    'ADJUST_CTA',
    'UPDATE_SETTINGS',
    'REORDER_PRODUCTS',
    'FEATURE_PRODUCT',
    'SWAP_PRODUCT',
    'ADD_PRODUCT',
    'REMOVE_PRODUCT',
    'MOVE_SECTION',
    'REMOVE_SECTION',
    'ADD_SECTION',
    'REPLACE_SECTION',
    'ADJUST_FLOATING_CTA',
    'OTHER',
];
exports.PAGE_LEVEL_SECTION_TYPE = 'PAGE';
exports.REVIEW_FINDING_VERDICTS = [
    'RESOLVED',
    'PARTIAL',
    'UNTOUCHED',
];
